// AuthContext.tsx

import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { getAuth, onAuthStateChanged, User } from 'firebase/auth';
import defaultAxios from 'axios';
import { backendUrl } from './common/constantVarialble';

// AuthContextProps 인터페이스 정의
interface AuthContextProps {
    user: User | null;
    userName: string | null;
    role: string | null;
}

// createContext 함수 호출 시 초기값의 타입을 명시
const AuthContext = createContext<AuthContextProps | undefined>(undefined);

// AuthProvider 컴포넌트 정의
export const AuthProvider = ({ children }: { children: ReactNode }) => {
    // 사용자 상태를 저장하는 state
    const [user, setUser] = useState<User | null>(null);
    // 추가 사용자 정보를 저장하는 state
    const [userName, setUserName] = useState<string | null>(null);
    const [role, setRole] = useState<string | null>(null);
    // Firebase Auth 객체 가져오기
    const auth = getAuth();

    // 사용자의 로그인 상태가 변경될 때마다 호출되는 useEffect
    useEffect(() => {
        // 로그인 상태 변경 감지를 위한 리스너 등록
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            // 사용자 상태 갱신
            setUser(user);

            // Fetch additional user information from your local database
            if (user) {
                try {
                    const { data } = await defaultAxios({
                        method: 'post',
                        //url: 'http://localhost:5000/api/request/',
                        url: backendUrl,
                        data: {
                            program_id: 'PERCENT-ADMIN-USER-L-LSTBYUSERID',
                            params: {
                                'p_user_id': user.uid,
                            },
                            page_index: -1,
                        },
                    });

                    // Check if user information is available
                    if (data && data.ok && data.data.length > 0) {
                        // Assuming 'USER_NAME' is the key in the response
                        setUserName(data.data[0].user_name);
                        setRole(data.data[0].role);
                        console.log("===========");
                        console.log(data.data[0].role);
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        });

        // 컴포넌트가 언마운트되거나 재랜더링될 때 리스너 제거
        return () => unsubscribe();
    }, [auth]);

    // AuthContext.Provider 컴포넌트 반환
    return (
        <AuthContext.Provider value={{ user, userName, role }}>
            {children}
        </AuthContext.Provider>
    );
};

// useAuth 커스텀 훅 정의
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
